import {Routes} from '@angular/router';
import {RoleGuard} from '../shared/auth/role.guard';
import {AdminComponent} from './admin-components/admin.component';

import {CompanyDashboardComponent} from './admin-components/company-dashboard/company-dashboard.component';
import {FeatureLockedGuard} from '@app/shared/auth/feature-locked.guard';
import {AdminMessages} from './admin.messages';
import {FeatureGuard} from '@app/shared/auth/feature.guard';
import { CompanyFeatures } from '@app/models/company-features.model';

export const AdminRoutes: Routes = [{
  path: '',
  component: AdminComponent,
  canActivate: [RoleGuard],
  data: {
    roles: ['ADMIN', 'FRANKLI_ADMIN'],
  },
  children: [
    {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
    {
      path: 'dashboard', component: CompanyDashboardComponent, data: { label: AdminMessages.ADMIN_DASHBOARD }, children: [
        {
          path: 'quick-start',
          loadChildren: () => import('../company-setup/company-setup.module').then(m => m.CompanySetupModule)
        },
        {
          path: 'company',
          loadChildren: () => import('./admin-modules/admin-company/admin-company.module').then(m => m.AdminCompanyModule)
        },
        {
          path: 'features',
          loadChildren: () => import('./admin-modules/admin-features/admin-features.module').then(m => m.AdminFeaturesModule),
          canActivate: [FeatureLockedGuard]
        },
        {
          path: 'integrations',
          loadChildren: () => import('./admin-modules/admin-integrations/admin-integrations.module').then(m => m.AdminIntegrationsModule)
        },
        {
          path: 'goals',
          canActivate: [FeatureGuard],
          data: {feature: CompanyFeatures.GOALS},
          loadChildren: () => import('./admin-modules/admin-goals/admin-goals.module').then(m => m.AdminGoalsModule)
        },
        {
          path: 'feedback',
          canActivate: [FeatureGuard],
          data: {feature: CompanyFeatures.FEEDBACK},
          loadChildren: () => import('./admin-modules/admin-feedback/admin-feedback.module').then(m => m.AdminFeedbackModule)
        },
        {
          path: 'surveys',
          canActivate: [FeatureGuard],
          data: {feature: CompanyFeatures.SURVEYS},
          loadChildren: () => import('./admin-modules/admin-surveys/admin-surveys.module').then(m => m.AdminSurveysModule)
        },
        {
          path: 'evaluations',
          canActivate: [FeatureGuard],
          data: {feature: CompanyFeatures.EVALUATION_CYCLES},
          loadChildren: () => import('./admin-modules/admin-evaluations/admin-evaluations.module').then(m => m.AdminEvaluationsModule)
        },
        {
          path: 'one-to-ones',
          canActivate: [FeatureGuard],
          data: {feature: CompanyFeatures.ONE_TO_ONE},
          loadChildren: () => import('./admin-modules/admin-one-to-ones/admin-one-to-ones.module').then(m => m.AdminOneToOnesModule)
        },
        {
          path: 'careers',
          canActivate: [FeatureGuard],
          data: {feature: CompanyFeatures.CAREERS},
          loadChildren: () => import('./admin-modules/admin-careers/admin-careers.module').then(m => m.AdminCareersModule)
        },
        {
          path: 'analytics',
          canActivate: [FeatureGuard],
          data: {feature: CompanyFeatures.ANALYTICS},
          loadChildren: () => import('../analytics/analytics.module').then(m => m.AnalyticsModule)
        }
      ]
    },
  ],
}];


